import { DropdownField } from '../../../types'
import { FieldTypes } from '../../FieldTypes'
import { icdCodeGroups, icdCodes, pregnancyPrioritizedIcd10Groups } from '../icdCodes'

export const antepartumIcd10Field: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Presenting condition ICD-10',
  options: icdCodes.map(icd => ({ id: icd.code, text: `${icd.code} - ${icd.description}` })),
  allowMultiple: true,
  searchable: true,
}

export const groupedIcd10Field: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'ICD-10',
  options: icdCodeGroups.map(group => ({
    title: group.name,
    options: group.codes.map(code => ({
      id: code.code,
      text: `${code.code} - ${code.description}`,
      keywords: code.keywords,
    })),
  })),
  allowMultiple: true,
  searchable: true,
}

export const pregnancyPrioritizedIcd10Field: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'ICD-10',
  options: pregnancyPrioritizedIcd10Groups.map(group => ({
    title: group.name,
    options: group.codes.map(code => ({
      id: code.code,
      text: `${code.code} - ${code.description}`,
      keywords: code.keywords,
    })),
  })),
  allowMultiple: true,
  searchable: true,
}
